import React, { useCallback } from "react";
// 从子路径引入，避免把 kaihong-design 全量组件（Table / ObsUpload 等）打进主应用首屏
import TenantSwitcher from "kaihong-design/es/TenantSwitcher";
import type { Tenant } from "kaihong-design/es/TenantSwitcher/type";
import { isGlobalTenantMode } from "@/utils/globalTenant";
import "./TenantSwitch.less";

/**
 * 顶部栏租户切换
 *
 * 直接使用 kaihong-design 的 TenantSwitcher：
 * - 平台模式（mode === 2）判断、租户列表拉取、切换确认弹窗、写入 X-Tenant-Id、整页刷新都由组件内部完成
 * - 组件仅在多租户模式下渲染，非多租户环境不需要外层再判断一次
 * - 切换成功后 autoReload 默认为 true，页面会自动刷新，这里不需要手动 reload
 */
const TenantSwitch: React.FC = () => {
  const handleTenantChange = useCallback((tenant: Tenant) => {
    // 初始化成功与切换成功都会进入这里。
    // 组件随后会自动刷新整页，主应用侧暂时无需额外处理，保留回调便于后续扩展。
    console.log("[tenant] current tenant:", tenant.id, tenant.name);
  }, []);

  const handleTenantInvalid = useCallback((invalid: boolean) => {
    if (invalid) {
      console.warn("[tenant] tenant is invalid, please select another one");
    }
  }, []);

  // 全局租户模式（tenant=all）下不展示租户切换，也不请求租户接口
  if (isGlobalTenantMode()) {
    return null;
  }

  return (
    <TenantSwitcher
      identifier="base"
      width={200}
      className="base-tenant-switcher"
      onTenantChange={handleTenantChange}
      onTenantInvalid={handleTenantInvalid}
    />
  );
};

export default TenantSwitch;
